import "./Footer.css"

import { Link } from 'react-router-dom'
function Footer() {
  return (
    <div>

     

      <div className="top">
        <p><a href="#">Back to top</a></p>
      </div>
      <div className="bottom">
        <div className="row1">
          <div className="col1">
            <p><strong>Get to Know Us</strong></p>
            <p>About Us</p>
            <p>Careers</p>
            <p>Press Releases</p>
            <p>Amazon Cares</p>
            <p>Gift a Smile</p>
          </div>
          <div className="col2">
            <p><strong>Connect with Us</strong></p>
            <p>facebook</p>
            <p>Twitter</p>
            <p>Instagram</p>

          </div>
        </div>


        <div className="row1">
          <div className="col3">
            <p><strong>Make Money With Us</strong></p>
            <p>Sell on Amazon</p>
            <p>Sell under Amazon Accelerator</p>
            <p>Amazon Global Selling</p>
            <p>Become an Affliate</p>
            <p>Fulfilment by Amazon</p>
            <p>Advertise Your Product</p>
            <p>Amazon Pay on Merchants</p>

          </div>

          <div className="col4">
            <p><strong>Let us Help You</strong></p>
            <p>COVID-19 and Amazon</p>
            <p>Your Account</p>
            <p>Returns Centre</p>
            <p>100% Purchase Protection</p>
            <p>Amzon App Download</p>
            <p>Amazon Assistant Download</p>
            <p>Help</p>

          </div>
        </div>



      </div>
      <div className="bottom3">
        <div className="img">
          <img className='header__logo' src='http://pngimg.com/uploads/amazon/amazon_PNG11.png' alt='amazon logo' />
          <div className="language">
            {/* <label for="cars">Language : </label>
                      <select name="cars" id="cars" className="language">
                        <option value="volvo">ENGLISH</option>
                        <option value="saab">TELUGU</option>
                        <option value="opel">TAMIL</option>
                        <option value="audi">HINDI</option>
                      </select> */}
          </div>
        </div>



      </div>
      <div ><pre className="countries"><p>     Australia Brazil  Canada  China  France  Germany Italy  Japan  Mexico  Netherlands  Poland  Singapore  Spain  Turkey  United Arab Emirates  United Kingdom  United States     <div>
        <div className="countries1">

          <div className="row">
            <div className="column1" >
              <p><strong>AdeBooks</strong> <p>Books,art<p>& collectibles</p></p>
              </p>


            </div>
            <div className="column2">
              <p><strong>Amazon Web Services</strong> <p>Scalable Cloud<p>Computing Service</p></p>
              </p>


            </div>
            <div className="column2">
              <p><strong>Audible</strong>  <p>Download<p>Audio Books</p></p>
              </p>


            </div>
          </div>
          <div className="row" >
            <div className="column2">
              <p><strong>AdeBooks</strong><p>Books,art<p>& collectibles</p></p>
              </p>

            </div>
            <div className="column2">
              <p><strong>DP Review</strong><p>Digitalt<p>Photography</p></p>
              </p>


            </div>
            <div className="column2">
              <p><strong>IMDb</strong> <p>Movies , TV <p>& Celebrities</p></p>
              </p>


            </div></div>
        </div>
        <div className="countries2"><p>Conditions of Use & SalePrivacy NoticeInterest-Based Ads© 1996-2021, Amazon.com, Inc. or its affiliates</p></div>
        <br />
      </div>
      </p></pre></div>








    </div>
  )
}

export default Footer;